<script>
  import TextInput from '../../../../components/inputs/text';
  import AvatarInput from '../../../../components/inputs/avatar';
  import TextAreaInput from '../../../../components/inputs/textarea';
  import Form from '../../../../components/inputs/form';

  export let value
</script>

<div>
  <Form>
    <div class="form-group">
      <TextInput bind:value={value.firstName} label={'First Name'} placeholder="First Name" />
    </div>
    <div class="form-group">
      <TextInput bind:value={value.lastName} label={'Last Name'} placeholder="Last Name" />
    </div>
    <div class="form-group">
      <TextInput bind:value={value.email} label={'Email'} placeholder="Email" />
    </div>
    <div class="form-group">
      <TextInput bind:value={value.phone} label={'Phone'} placeholder="Phone" />
    </div>
    <div class="form-group">
      <TextAreaInput bind:value={value.bio} label={'Bio'} placeholder="Bio" />
    </div>
    <div class="form-group">
      <AvatarInput bind:value={value.avatar} label={'Photo'} placeholder="Photo" />
    </div>
  </Form>
</div>